// extracted by mini-css-extract-plugin
export var link = "_ur-0";